import { UUID } from "@opendaw/lib-std";
export var MsgType;
(function (MsgType) {
    MsgType[MsgType["ChunkData"] = 1] = "ChunkData";
    MsgType[MsgType["TransferStart"] = 2] = "TransferStart";
    MsgType[MsgType["TransferComplete"] = 3] = "TransferComplete";
    MsgType[MsgType["ChunkAck"] = 4] = "ChunkAck";
    MsgType[MsgType["Cancel"] = 5] = "Cancel";
})(MsgType || (MsgType = {}));
export const CHUNK_SIZE = 65_536;
export const HEADER_SIZE = 1 + UUID.length + 4; // msgType(1) + assetId(16) + chunkNum(4) = 21
export const encodeHeader = (msgType, assetId, chunkNum) => {
    const buffer = new ArrayBuffer(HEADER_SIZE);
    const view = new DataView(buffer);
    const bytes = new Uint8Array(buffer);
    view.setUint8(0, msgType);
    bytes.set(assetId, 1);
    view.setUint32(1 + UUID.length, chunkNum, false);
    return buffer;
};
export const decodeHeader = (buffer) => {
    const view = new DataView(buffer);
    const bytes = new Uint8Array(buffer);
    const msgType = view.getUint8(0);
    const assetId = new Uint8Array(bytes.buffer, 1, UUID.length);
    const chunkNum = view.getUint32(1 + UUID.length, false);
    return { msgType, assetId, chunkNum };
};
export const encode = (msgType, assetId, chunkNum, payload) => {
    const buffer = new ArrayBuffer(HEADER_SIZE + payload.byteLength);
    const bytes = new Uint8Array(buffer);
    const view = new DataView(buffer);
    view.setUint8(0, msgType);
    bytes.set(assetId, 1);
    view.setUint32(1 + UUID.length, chunkNum, false);
    bytes.set(payload, HEADER_SIZE);
    return buffer;
};
export const decode = (buffer) => {
    const view = new DataView(buffer);
    const bytes = new Uint8Array(buffer);
    const msgType = view.getUint8(0);
    const assetId = new Uint8Array(bytes.buffer, 1, UUID.length);
    const chunkNum = view.getUint32(1 + UUID.length, false);
    const payload = new Uint8Array(bytes.buffer, HEADER_SIZE);
    return { msgType, assetId, chunkNum, payload };
};
export const split = (data, chunkSize = CHUNK_SIZE) => {
    const bytes = new Uint8Array(data);
    const chunks = [];
    for (let offset = 0; offset < bytes.byteLength; offset += chunkSize) {
        chunks.push(bytes.slice(offset, Math.min(offset + chunkSize, bytes.byteLength)));
    }
    return chunks;
};
export const reassemble = (chunks) => {
    let totalLength = 0;
    for (const chunk of chunks) {
        totalLength += chunk.byteLength;
    }
    const result = new Uint8Array(totalLength);
    let offset = 0;
    for (const chunk of chunks) {
        result.set(chunk, offset);
        offset += chunk.byteLength;
    }
    return result.buffer;
};
